// ** React Imports
import { useState, useEffect, useRef } from 'react'
import { Link } from "react-router-dom";
import Header from "../Header/Header";
import { Layout } from "../Layout/Layout";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import axios from 'axios';
import Swal from 'sweetalert2';

export default function Profile() {
    const [imgSrc, setImgSrc] = useState('assets/img/avatars/1.png')
    const authUser = localStorage.getItem('FF-authUser');
    const user = JSON.parse(authUser);
    const inputFile = useRef(null);

    const onFileChange = (file) => {
        formik.setFieldValue('image', file);
        const reader = new FileReader();
        reader.onload = () => {
        setImgSrc(reader.result);
        // console.log(reader.result)
        // formik.setFieldValue('image', reader.result);
        }
        reader.readAsDataURL(file);
    };

    const resetImage = () => {
        if (inputFile.current) {
            inputFile.current.value = "";
            inputFile.current.type = "text";
            inputFile.current.type = "file";
        }
        setImgSrc('assets/img/avatars/1.png');
        formik.setFieldValue('image','');
    };

    // useEffect(() => {
    //     setImgSrc(imgSrc)
    // },[imgSrc]);

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        email: Yup.string().email('Invalid email address').required('Email is required')
    });

    const initialValues = {
        id: user.id,
        name: user.name,
        email: user.email,
        image: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: values => {
            handleSubmit(values);
        }
    });

    useEffect(() => {
        if (Object.keys(user).length !== 0) {
          setImgSrc(user.image ? user.image : 'assets/img/avatars/1.png');
          formik.setValues({
            id: user.id,
            name: user.name,
            email: user.email,
            image: null,
          });
        }
      }, [formik.setValues]);

    const handleSubmit = async (values) => {
        try {

          const formData = new FormData();
          formData.append('id', values.id);
          formData.append('name', values.name);
          formData.append('email', values.email);
          formData.append('image', values.image);
          // console.log("formData====",formData);
    
          let res = await axios.post('/api/users/updateProfile', formData);
          if(res.data.success){
              const authUserJSON = localStorage.getItem('FF-authUser');
              let authUser = JSON.parse(authUserJSON);
              if (authUser) {            
                // if(values.image != ''){
                  authUser.image = res.data.data.image
                // }
                authUser.name = res.data.data.name;
                authUser.email = res.data.data.email;
                try {
                  localStorage.setItem('FF-authUser', JSON.stringify(authUser));
                } catch (error) {
                  console.error("Error storing authUser:", error);
                }
              } else {
                console.error("authUserJSON is not valid JSON:", authUserJSON);
              }
            Swal.fire(res.data.message, '', 'success').then(result => {
              window.location.reload();
            })
          }
          else{
            Swal.fire(res.data.message, '', 'info')
          }
        } catch (error) {
          Swal.fire('Error updating profile:'+ error);
        }
    }

    return(
        <Layout>
        <Header pageTitle="My Profile" />
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                    <div className="col-md-8">
                        <ul className="nav nav-pills flex-column flex-md-row mb-3">
                            <li className="nav-item">
                                <Link className="nav-link active"><i className="bx bx-user me-1"></i> Account</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/security" className="nav-link"><i className="bx bx bxs-key me-1"></i> Security</Link>
                            </li>
                        </ul>
                        <div className="card mb-4">
                        <form id="formAccountSettings" method="POST" onSubmit={formik.handleSubmit} encType="multipart/form-data">

                            <h5 className="card-header border-0">Profile Details</h5>                           
                            <div className="card-body">
                                <div className="d-flex align-items-start align-items-sm-center gap-4">
                                    <img src={imgSrc} alt="user-avatar" className="d-block rounded" height="100" width="100" id="uploadedAvatar" />
                                    <div className="button-wrapper">
                                        <label htmlFor="upload" className="btn btn-primary me-2 mb-4" tabIndex="0">
                                            <span className="d-none d-sm-block">Upload new photo</span>
                                            <i className="bx bx-upload d-block d-sm-none"></i>
                                            <input type="file" id="upload" className="account-file-input" hidden accept="image/png, image/jpeg"
                                            name='image'
                                            onChange={(e) => onFileChange(e.target.files[0])} 
                                            ref={inputFile}/>
                                        </label>
                                        {/* <button type="button" className="btn btn-outline-secondary account-image-reset mb-4" onClick={() => setImgSrc('assets/img/avatars/1.png')}>
                                            <i className="bx bx-reset d-block d-sm-none"></i>
                                            <span className="d-none d-sm-block">Reset</span>
                                        </button> */}
                                        <button type="button" className="btn btn-outline-secondary account-image-reset mb-4" onClick={resetImage}>
                                            <i className="bx bx-reset d-block d-sm-none"></i>
                                            <span className="d-none d-sm-block">Reset</span>
                                        </button>

                                        <p className="text-muted mb-0">Allowed JPG, GIF or PNG. Max size of 800K</p>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-0" />
                            <div className="card-body">
                                <div className="row">
                                    <div className="mb-3 col-md-6">
                                        <label htmlFor="Name" className="form-label">Name</label>
                                        <input className="form-control" type="text" id="Name" name="name"
                                        onChange={formik.handleChange} 
                                        onBlur={formik.handleBlur} 
                                        value={formik.values.name}
                                        placeholder="Rajiv Gangwar" autoFocus />
                                        {formik.touched.name && formik.errors.name && (
                                            <div className="text-danger">{formik.errors.name}</div>
                                        )}
                                    </div>                                      
                                    <div className="mb-3 col-md-6">
                                        <label htmlFor="email" className="form-label">Email Id</label>
                                        <input className="form-control" type="email" id="email" name="email"                                        
                                        onChange={formik.handleChange} 
                                        onBlur={formik.handleBlur} 
                                        value={formik.values.email}
                                        placeholder="Rajiv.doe@example.com" disabled />
                                        {formik.touched.email && formik.errors.email && (
                                            <div className="text-danger">{formik.errors.email}</div>
                                        )}
                                    </div>                                       
                                    </div>
                                <div className="mt-2">
                                    <button type="submit" className="btn btn-primary me-2">Save changes</button>
                                    {/* <button type="reset" className="btn btn-outline-secondary">Cancel</button> */}
                                </div>
                            </div> 

                        </form>

                        </div>                       
                    </div>
                </div>
            </div>
        </Layout>
    )
}